<template>
  <div class="container-atb">
    <div class="header">
      <PartnerLogo icon="atb/logo-atb"></PartnerLogo>
      <PartnerLogo icon="logo"></PartnerLogo>
    </div>

    <h1 class="title divider_top">Информация о Страховщике <br> ООО «МАКС-Жизнь»</h1>

    <section class="divider__between-blocks">
      <h2 class="subtitle">Полное и сокращенное наименование Страховщика, используемый знак обслуживания:</h2>
  
      <div>
        <p><strong>Номер и дата выдачи лицензии на право осуществления страховой деятельности, срок их действия:</strong> ООО «МАКС-Жизнь» лицензии банка России СЛ Nº 4013 от 13.08.2015 г., СЖ Nº 4013 от 13.08.2015 г. Общество с Ограниченной Ответственностью «МАКС страхование жизни»</p>
      </div>
      <div>
        <p><strong>Сведения о правоустанавливающих документах,</strong> включая сведения об ОГРН, ИНН, регистрационный 
  номер в едином государственном реестре субъектов страхового дела:</p>
        <a href="https://makclife.ru/o-kompanii/" target="_blank">подробнее</a>
      </div>
      <div>
        <p><strong>Членство в саморегулируемой организации </strong>(включая информацию о дате приема в члены саморегулируемой организации), об исключении из саморегулируемой организации (включая информацию о дате исключения из саморегулируемой организации):</p>
        <a href="https://makclife.ru/o-kompanii/" target="_blank">подробнее</a>
      </div>
      <div>
        <p><strong>Базовый стандарт защиты прав и интересов физических и юридических лиц — </strong>получателей финансовых услуг, оказываемых членами саморегулируемых организаций, объединяющих страховые организации и иностранные страховые организации (утв. Банком России, Протокол от 01.10.2024 N КФНП-29):</p>
        <a href="https://makclife.ru/klientskiy-servis/informatsiya-dlya-klientov.php" target="_blank">подробнее</a>
      </div>
    </section>

    <section class="divider__between-blocks">
      <h2 class="subtitle">Контактные реквизиты Страховщика:</h2>

      <div>
        <div>
          <p><strong>Адрес (место нахождения) Страховщика, его офисов (филиалов, представительств, иных обособленных подразделений, осуществляющих взаимодействие с получателями страховых услуг) с указанием их назначения и режима работы:</strong></p>
          <ul>
            <li>Общество с ограниченной ответственностью Страховая компания «МАКС страхование жизни»</li>
            <li>ООО «МАКС-Жизнь»</li>
            <li>Юридический адрес: РФ, 115184, г. Москва, ул. Малая Ордынка, д. 50</li>
            <li>Центр обслуживания клиентов: РФ, 115184, г. Москва, ул. Малая Ордынка, д. 50</li>
            <li>Электронная почта: <a href="mailto:info@makclife.ru">info@makclife.ru</a></li>
          </ul>
        </div>
      </div>
      <div>
        <h3><strong>Адрес официального сайта страховой организации</strong></h3>
        <a href="https://makclife.ru/" target="_blank">открыть</a>
      </div>
      <div>
        <div style="display: flex; align-items: end;">
          <h3><strong>Время работы: 9:00 - 18:00 </strong>&nbsp;</h3>
          <span> (кроме выходных и нерабочих праздничных дней)</span>
        </div>
      </div>
      <div>
        <h3><strong>Контактный телефон: </strong>+7 (499) 350-86-89 (Москва), +7 (800) 333-90-13</h3>
      </div>
    </section>

    <section class="divider__between-blocks">
      <h2 class="subtitle">Правоустанавливающие документы:</h2>

      <div>
        <div>
          <p><strong>Правоустанавливающие документы:</strong></p>
          <p>Полная информация о страховой компании «МАКС-Жизнь»</p>
        </div>
        <a href="https://makclife.ru/o-kompanii/" target="_blank">подробнее</a>
      </div>
    </section>

    <section class="divider__between-blocks" style="margin-bottom: 60px;">
      <h2 class="subtitle">Дополнительная информация:</h2>

      <div>
        <div>
          <p><strong>Страховая группа, в состав которой входит Страховщик (при наличии):</strong></p>
          <p>Страховая группа МАКС</p>
        </div>
      </div>
      <div>
        <p><strong>Перечень осуществляемых Страховщиком видов страхования подробнее</strong></p>
        <a href="https://makclife.ru/o-kompanii/" target="_blank">подробнее</a>
      </div>
      <div>
        <p><strong>Орган, осуществляющий полномочия по контролю и надзору за страховой деятельностью
страховщиков (с указанием ссылки на сайт или официальный адрес)</strong></p>
        <a href="https://makclife.ru/klientskiy-servis/informatsiya-dlya-klientov.php" target="_blank">подробнее</a>
      </div>
      <div>
        <p><strong>Способы и адреса для направления обращений получателей страховых услуг Страховщику,
в органы, осуществляющие полномочия по контролю и надзору за деятельностью страховщиков, 
в саморегулируемую организацию, а также в орган досудебного рассмотрения споров (при наличии)</strong></p>
        <a href="https://makclife.ru/klientskiy-servis/informatsiya-dlya-klientov.php" target="_blank">подробнее</a>
      </div>
      <div>
        <p><strong>Способы защиты прав получателей страховых услуг, включая информацию о наличии возможности и способах досудебного урегулирования спора, в том числе о процедуре
 медиации (при ее наличии)</strong></p>
        <a href="https://makclife.ru/klientskiy-servis/informatsiya-dlya-klientov.php" target="_blank">подробнее</a>
      </div>
      <div>
        <p><strong>Иная информация, размещение которой предусмотрено законодательством Российской Федерации, с учетом требований к месту ее размещения</strong></p>
        <a href="https://makclife.ru/klientskiy-servis/informatsiya-dlya-klientov.php" target="_blank">подробнее</a>
      </div>
      <div>
        <p><strong>Годовая бухгалтерская (финансовая) отчетность Страховщика и подтверждающее ее достоверность аудиторское заключение за три предыдущих отчетных года
</strong></p>
        <a href="https://makclife.ru/o-kompanii/finansovaya-otchyetnost.php" target="_blank">подробнее</a>
      </div>
      <div>
        <p><strong>Годовая консолидированная финансовая отчетность и подтверждающее ее достоверность
аудиторское заключение за три предыдущих отчетных года</strong></p>
        <a href="https://makclife.ru/o-kompanii/finansovaya-otchyetnost.php" target="_blank">подробнее</a>
      </div>
      <div>
        <p><strong>Сведения о деятельности Страховщика, об опыте его работы по видам страхования</strong></p>
        <a href="https://makclife.ru/o-kompanii/" target="_blank">подробнее</a>
      </div>
      <div>
        <p><strong>Правила страхования</strong></p>
        <a href="https://makclife.ru/o-kompanii/pravila-i-tarify.php" target="_blank">подробнее</a>
      </div>
    </section>
  </div>
</template>

<script>
import MakcLogo from '@/create/components/landingsConstructor/MakcLogo.vue';
import PartnerLogo from '@/create/components/landingsConstructor/PartnerLogo.vue';

  export default {
    components: {
      MakcLogo,
      PartnerLogo,
    },
    data() {
      return {

      }
    },
    computed: {
      windowWidth() {
        return window.innerWidth
      },
    },
    methods: {
      
    },
    
    mounted() {
        
    }
  }
</script>

<style lang="scss" scoped>
// -------------------- шрифты для этого лендинга

@import url('https://fonts.googleapis.com/css2?family=Wix+Madefor+Text:wght@400..800&display=swap');

// -------------------- стили этого лендинга
.container-atb {                    // десктоп контейнер
  max-width: 1320px;
  margin: 0 auto;
  width: calc(100vw - 40px);

  h1, h2, h3, p, a, li {
    font-family: "Wix Madefor Text", sans-serif;
    color: #3C3C3B;
    text-align: justify;
  }

  section {
    &> div{
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 10px;
      padding: 30px 20px;
      background-color: #F4F4F4;

      &> a {
        margin-left: 50px;
        min-width: 127px;
        border-radius: 10px;
        text-align: center;
        background-color: #FE5000;
        font-weight: 700;
        font-size: 16px;
        line-height: 38px;
        color: #FFFFFF;
      }
    }

    p {
      font-weight: 400;
      font-size: 16px;
      line-height: 110%;
    }

    
    ul {
      margin-top: 30px;
      margin-left: 26px;
      li {
        list-style-type: disc;
        &::marker {
          color: #FE5000;
        }
      }
    }
    
    h3 {
      font-weight: 400;
      font-size: 28px;
      line-height: 110%;
    }
  } 
}

.divider {                          // разделители между разными блоками и подблоками
  &__top {
    margin-top: 50px;
  }

  &__between-blocks {
    margin-top: 30px;
  }
}

.header {                           // шапка с логотипами
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .partner:nth-child(2) {
    width: 157px;
  }
}

.title {                            // заголовок большой (Оформление, Страхователь, Застрахованный...)
  font-weight: 700;
  font-size: 50px;
  line-height: 110%;
  margin-top: 50px;
}

.subtitle {                         // подзаголовок (Параметры договора страхования, Персональные данные, Документы)
  font-weight: 700;
  font-size: 28px;
  line-height: 110%;
  
}


// ------------------------ мобильная верстка ------------------------

@media (max-width: 480px) {
  .divider {                          // разделители между разными блоками и подблоками
    &__top {
      margin-top: 40px;
    }

    &__between-blocks {
      margin-top: 40px;
    }
  }

  .header {                           // шапка с логотипами
    margin-top: 40px;
    width: max-content;
    flex-direction: column-reverse;
    gap: 12px;
    
    :deep(.makc__logo) {
      width: 31px;
    }
    
    :deep(.makc__block) {
      margin-left: 10px;
      top: 0;
      gap: 2px;
    }

    :deep(.makc__title) {
      font-size: 16px;
    }

    :deep(.makc__subtitle) {
      font-size: 12px;
    }

    :deep(.partner__logo) {
      width: 142px;
    }
  }

  .title {                            // заголовок большой (Оформление, Страхователь, Застрахованный...)
    font-size: 24px;

    &__description {
      font-size: 4.7vw;
    }
  }

  .subtitle {                         // подзаголовок (Параметры договора страхования, Персональные данные, Документы)
    font-size: 16px;
  }
}
</style>